import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PAYOR, checkRole, getBrokersList, getDistanceFromLatLon, legTypeMap, timeCalculation } from '../../../utils/utils.common';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment-timezone';
import * as _ from 'underscore';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { MapsAPILoader } from '@agm/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { UserRoles } from '../../shared/layout/menu-service/menu.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';

@Component({
  selector: 'app-operations-v2',
  templateUrl: './operations-v2.component.html',
  styleUrls: ['./operations-v2.component.css']
})
export class OperationsV2Component implements OnInit, AfterViewInit, OnDestroy {
  legTypeMap: any = legTypeMap;
  payorList = PAYOR;
  duration = 10 * 1000; // 10 seconds
  tripAssistanceTimer;
  user;
  search = '';
  selectedCorporate = [];
  brokers = getBrokersList;
  currentTime;
  trips = [];
  proposedTrips = [];
  markedReadyTrips = [];
  alarmingTrips = [];
  inprogressTrips = [];
  scheduledTrips = [];
  cancelledTrips = [];
  settingInterval;

  componentType;
  notesModalObj;
  assignTripModalObj;
  tripDetailModalObj;
  live;
  counter: number = 10;
  tripAssistanceList;
  selectedTripSection;
  selectedTripId;

  @ViewChild('timer', { static: true }) timer;
  view = 'grid';
  directionMatrixService;
  timeZone;
  isGoogleApprox = false;
  showSlideFilter = false;
  isLocalApprox = false;
  subscription: Subscription;
  subMenu = 'v2';
  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  selectedServiceArea = [];
  preServiceAreas = {};
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];

  stationManagerList = [];
  filteredStationManagers = [];
  selectedStationManager = [];
  preStaffList = {};
  isAllowRates = false;
  isFarmoutModal = false;
  farmoutDetails;
  isFarmoutIntegration = false; preAssistList: any
  isRdispatcher = false;
  showCheckbox = false;
  farmoutToggle = false;
  lyftDetailsModalObj;
  isAutoFarmoutDispatch = false;

  columnsSortOrder: any = {
    milage: '',
    preSpecialRate: '',
    scheduleTime: '',
    appointmentTime: ''
  }

  editTripModalObj;
  partialEditModalObj;
  isStandingOrderClone = false;
  timeFormat: string = 'HHmm';
  advanceOnscene: any = null;
  editTaxiRideModalObj: any;

  constructor(
    private assistService: AssistService,
    private assignTripService: AssigTripsService,
    private socketService: SocketService,
    private mapsAPILoader: MapsAPILoader,
    private sharedDataService: SharedDataService,
    private corporateService: CorporateService,
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService,
    private staffService: StaffService
  ) { }

  ngOnInit() {
    this.getServiceAreas();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getCorporate();
    this.getAssisData();
    window.addEventListener("keyup", this.initializeTimer);
    this.mapsAPILoader.load().then(async () => {
      this.directionMatrixService = new google.maps.DistanceMatrixService()
      this.getUser();
    });

    this.socketService.addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          if (data.success && this[this.selectedTripSection] && this[this.selectedTripSection].length) {
            const selectedTrip = this[this.selectedTripSection].find((x) => x._id === this.selectedTripId);
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
            this.selectedTripSection = null;
            this.selectedTripId = null;
          }
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });
  }

  initializeTimer = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.showCheckbox = !this.showCheckbox;
    }
  };


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (user.timeFormat) {
            this.timeFormat = user.timeFormat;
          }
          // Company login
          if (user.isAdvanceOnscene) {
            this.advanceOnscene = user.isAdvanceOnscene;
          }
          else if (user.company && user.company.isAdvanceOnscene) {
            this.advanceOnscene = user.company.isAdvanceOnscene;
          }

          if (user.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = user.isFarmout
          }

          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }

          this.timeZone = user.timeZone;
          this.getStaffList();
          this.getAllTrips();
          this.listenSocket();
          const myUser = user.company ? user.company : user;
          if (myUser.isTripAssistance) {
            this.getTripAssistanceList();
            this.getTripAssistance();
          }
          if (this.user.hasOwnProperty('isListView') && this.user.isListView) {
            this.setView('list');
          }
          if (this.user.hasOwnProperty("autoFarmoutDispatch")) {
            this.isAutoFarmoutDispatch = this.user.autoFarmoutDispatch;
          }
          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  getTripAssistanceList() {
    this.assignTripService
      .getTripAssistanceList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssistanceList = data;
        }
      })
  }

  processTripAssistace(trip) {
    sweetAlert('Alert', `Are you sure you want to ${trip.isDone ? 'unmarked' : 'mark'} ready?`, 'warning', 'Yes', 'No')
      .then((result) => {
        if (result.value) {
          let payload = trip;

          if (trip.isDone) {
            payload.isDone = false;
          } else {
            payload.isDone = true;
          }
          this.assignTripService
            .processTripAssistance(trip._id, payload)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(data => {
              if (data) {
                this.tripAssistanceList.array.forEach(item => {
                  if (item._id === data._id) {
                    item = data;
                  }
                });


              }
            })
        }
      });
  }

  // incrementCounter() {
  //   // Increment the counter
  //   this.counter--;
  //    setTimeout(() => {
  //     if(this.counter == 0){
  //       this.getAllTrips();
  //       this.counter = 10;
  //     }
  //     this.incrementCounter();
  //   }, 1000);
  // }

  getAllTrips() {
    this.assignTripService
      .getTripsForAssignDashboard()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timer.start();
          this.currentTime = data.currentTime;
          if (this.farmoutToggle) {
            this.trips = data.assigns.filter(trip => trip.isUber);
          } else {
            this.trips = data.assigns;
          }
          this.filterTrips();
          const column = Object.keys(this.columnsSortOrder)
            .find(key => this.columnsSortOrder[key]);
          if (column) {
            this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
            this.sortTrips(column);
          }
        }
      });
  }

  async filterTrips() {
    this.proposedTrips = [];
    this.markedReadyTrips = [];
    this.alarmingTrips = [];
    this.inprogressTrips = [];
    this.scheduledTrips = [];
    this.cancelledTrips = [];
    let onBoardingTrips = [];
    let cooperates = [];
    let serviceAreas = [];
    let stationManagers = [];
    this.trips.sort((a, b) => {
      if (a.scheduleTime < b.scheduleTime) return -1;
      if (a.scheduleTime < b.scheduleTime) return 1;
      return 0;
    });
    this.trips.forEach((trip) => {
      trip.isWillcall = moment(trip.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
      const time = timeCalculation(trip, this.currentTime);
      trip.time = time;

      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }

      if (trip.driver && trip.driver.stationManager) {

        if (this.isRdispatcher) {
          if (trip.driver.stationManager === this.user.sId) {
            stationManagers.push(trip.driver.stationManager);
          }
        } else {
          stationManagers.push(trip.driver.stationManager);
        }

      }

      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }

      if (trip.isReadyForPickup) {
        this.markedReadyTrips.push(trip);
      }

      if (trip.isProposedReadyTime) {
        this.proposedTrips.push(trip);
      }

      if (trip.status === 'cancelled') {
        this.cancelledTrips.push(trip);
      } else if (trip.status === 'inprogress') {
        if (this.isGoogleApprox || this.isLocalApprox) {
          this.setApproximateTime(trip);
        } else {
          this.setDefaultApproximation(trip);
        }
        if (trip.job && (trip.job.memberNotVisible || trip.job.isMemberLoading)) {
          onBoardingTrips.push(trip);
        } else {
          this.inprogressTrips.push(trip);
        }
      } else if ((time <= 60) || trip.status === 'declined' || trip.status === 'bumped') {
        this.alarmingTrips.push(trip);
      } else if (time > 60) {
        this.scheduledTrips.push(trip);
      }
    });
    serviceAreas = _.uniq(serviceAreas).sort();
    stationManagers = _.uniq(stationManagers).sort();

    cooperates = _.uniq(cooperates).sort();

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(c => serviceAreas.includes(c._id));
    }


    if (stationManagers && stationManagers.length) {
      this.filteredStationManagers = this.stationManagerList.filter(c => stationManagers.includes(c._id));
    }

    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    onBoardingTrips.sort((a, b) => {
      if (a.scheduleTime < b.scheduleTime) return -1;
      if (a.scheduleTime < b.scheduleTime) return 1;
      return 0;
    });
    this.inprogressTrips.sort((a, b) => {
      if (a.scheduleTime < b.scheduleTime) return -1;
      if (a.scheduleTime < b.scheduleTime) return 1;
      return 0;
    });
    this.inprogressTrips = [...onBoardingTrips, ...this.inprogressTrips];
    const x = {};

    this.inprogressTrips.forEach(t => {
      if (t.driver) {
        x[t.driver._id] = {
          isAlarmingFound: false,
          isScheduledFound: false,
          approxDO: t.approxDO, scheduleTime: t.scheduleTime,
          jobOriginLatitude: t.jobOriginLatitude,
          jobOriginLongitude: t.jobOriginLongitude,
          jobDestinationLatitude: t.jobDestinationLatitude,
          jobDestinationLongitude: t.jobDestinationLongitude
        };
      }
    });

    const drivers = Object.keys(x);
    this.alarmingTrips.forEach(trip => {
      if (
        trip.driver && trip.driver._id &&
        drivers.includes(trip.driver._id) &&
        !x[trip.driver._id].isAlarmingFound &&
        !x[trip.driver._id].isScheduledFound && // un nessecity
        moment(trip.scheduleTime).isAfter(moment(x[trip.driver._id].scheduleTime))
      ) {
        x[trip.driver._id].isAlarmingFound = true;
        this.setNextTripPickupTime(x[trip.driver._id], trip);
      }
    })
    this.scheduledTrips.forEach(trip => {
      if (
        trip.driver && trip.driver._id &&
        drivers.includes(trip.driver._id) &&
        !x[trip.driver._id].isAlarmingFound &&
        !x[trip.driver._id].isScheduledFound &&
        moment(trip.scheduleTime).isAfter(moment(x[trip.driver._id].scheduleTime))
      ) {
        x[trip.driver._id].isScheduledFound = true;
        this.setNextTripPickupTime(x[trip.driver._id], trip);
      }
    })
  }

  async setNextTripPickupTime(inprogressTrip, nextTrip) {
    const distanceAndTime = getDistanceFromLatLon(
      inprogressTrip.jobDestinationLatitude, inprogressTrip.jobDestinationLongitude,
      nextTrip.jobOriginLatitude, nextTrip.jobOriginLongitude
    );
    let minutesToAdd = 0;
    if (distanceAndTime) {
      minutesToAdd = distanceAndTime.duration;
      if (nextTrip.tripRequirement === 'WAV') {
        minutesToAdd += 5;
      } else if (nextTrip.tripRequirement === 'Stretcher') {
        minutesToAdd += 15;
      } else {
        minutesToAdd += 2;
      }
      let approxPU = moment(inprogressTrip.approxDO).tz(this.timeZone).add(minutesToAdd, 'minutes');
      nextTrip.approxPU = approxPU.toISOString();
      nextTrip.puTimeDiff = moment(nextTrip.scheduleTime).tz(this.timeZone).diff(approxPU, 'minutes', true);
      // nextTrip.doTimeDiff = nextTrip.puTimeDiff;
      // for the estimated Do
      let mins = (parseFloat(nextTrip.milage) / 0.621371 / 50) * 60;
      let approxDO = moment(nextTrip.approxPU).tz(this.timeZone).add(mins, 'minutes');
      nextTrip.approxDO = approxDO.toISOString();
      nextTrip.doTimeDiff = moment(nextTrip.appointmentTime).tz(this.timeZone).diff(approxDO, 'minutes', true);
    }

  }

  listenSocket() {
    this.socketService.addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          this.trips.filter((trip) => {
            if (data.assign._id === trip._id) {
              trip.isReadyForPickup = data.assign.isReadyForPickup;
              // this.getAllTrips();
            }
          });
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });

    this.socketService.addListener(Events.GET_MILES_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // this.inprogressTrips.filter((trip) => {
          //   if (data.assign._id === trip._id) {
          //     trip.isReadyForPickup = data.assign.isReadyForPickup;
          //     this.getAllTrips();
          //   }
          // });
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });
  }

  markReadyTrip(assign) {
    const tempAssign = JSON.parse(JSON.stringify(assign));
    const payload = {
      assignId: tempAssign._id,
      isReadyForPickup: !tempAssign.isReadyForPickup
    }
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, payload);
  }

  getETA(trip, objectName) {
    this.assignTripService
      .getETA(trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (this[objectName] && this[objectName].length) {
          const selectedTrip = this[objectName].find((x) => x._id === data._id);
          if (selectedTrip) {
            selectedTrip.etaMessage = data.etaMessage;
          }
        }
      });
  }

  loadedMiles(trip, objectName) {
    this.selectedTripSection = objectName;
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true
    }
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  assignTrip(trip) {
    this.assignTripModalObj = trip;
    this.componentType = 'dashboard';
  }

  onAssignTrip(tripStatus: string) {
    this.getAllTrips();
    this.assignTripModalObj = null;
    this.componentType = null;
  }

  viewNotes(trip) {
    this.notesModalObj = trip;
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  getBroker(key) {
    return getBrokersList[key];
  }

  sortMethod(a, b) {
    return new Date(a.key) > new Date(b.key) ? 1 : -1;
  }

  // ngAfterViewInit() {
  // }

  ngAfterViewInit(): void {
    this.timer.start();
    // this.getAllTrips();
  }

  onTimerComplete(): void {
    this.timer.init()
    this.getAllTrips();

  }

  getTripAssistance() {
    // if (this.tripAssistanceTimer) return;
    if (this.tripAssistanceTimer) {
      clearInterval(this.tripAssistanceTimer);
    }

    this.tripAssistanceTimer = setInterval(() => {
      this.getTripAssistanceList();
    }, 30000)
  }
  formatMyTimer(timer): void {
    if (timer)
      this.timer.formattedTimeLeft = timer.split(':')[1];
    else
      this.timer.formattedTimeLeft = '0'
  }

  async getDistance(origin, destination) {
    let seconds;

    const request: any = {
      origins: [new google.maps.LatLng(origin.lat, origin.lng)],
      destinations: [new google.maps.LatLng(destination.lat, destination.lng)],
      travelMode: google.maps.TravelMode.DRIVING
    }

    if (this.isGoogleApprox) {
      const res = await this.directionMatrixService.getDistanceMatrix(request, (response, status) => {
        if (status === 'OK' && response) {
          if (response.rows && response.rows.length) {
            const elements = response.rows[0].elements;
            if (elements && elements.length && elements[0].status === "OK") {
              const data = elements[0];
              seconds = data.duration.value;
              return seconds;
            }
          }
        }
        return null;
      });
    } else {
      const result = getDistanceFromLatLon(request.origins[0].lat(), request.origins[0].lng(), request.destinations[0].lat(), request.destinations[0].lng());
      // converting per miles
      if (result.distance <= 5) {
        seconds = 5 * 60;
      } else {
        seconds = (result.distance + 5) * 60;
      }
    }

    return seconds;
  }

  async setApproximateTime(trip) {
    if (trip.job && trip.job.trackInfoJob && this.isEventExist(trip.job.trackInfoJob.jobAccepted)) {
      const res1 = await this.getDistance({ lat: trip.job.trackInfoJob.jobAccepted.coords[1], lng: trip.job.trackInfoJob.jobAccepted.coords[0] }, { lat: trip.jobOriginLatitude, lng: trip.jobOriginLongitude });
      if (res1) {
        // jobAccepted time
        let approxPU = moment(trip.job.trackInfoJob.jobAccepted.time).tz(this.timeZone).add(res1, 'seconds');
        trip.approxPU = approxPU.toISOString();
        let scheduleTime = moment(trip.scheduleTime).tz(this.timeZone);
        trip.puTimeDiff = scheduleTime.diff(approxPU, 'minutes');
        trip.puTimeMsg = trip.puTimeDiff < 0 ? 'Late' : 'Early';

        if (this.isEventExist(trip.job.trackInfoJob.jobStarted)) {
          const res = await this.getDistance({ lat: trip.job.trackInfoJob.jobStarted.coords[1], lng: trip.job.trackInfoJob.jobStarted.coords[0] }, { lat: trip.jobDestinationLatitude, lng: trip.jobDestinationLongitude });
          if (res) {
            let approxDO = moment(trip.job.trackInfoJob.jobStarted.time).tz(this.timeZone).add(res, 'seconds');
            trip.approxDO = approxDO.toISOString();
            let appointmentTime = moment(trip.appointmentTime).tz(this.timeZone);
            trip.doTimeDiff = appointmentTime.diff(approxDO, 'minutes', true);
            trip.doTimeMsg = trip.doTimeDiff < 0 ? 'Late' : 'Early';
          }
        } else {
          const res = await this.getDistance({ lat: trip.jobOriginLatitude, lng: trip.jobOriginLongitude }, { lat: trip.jobDestinationLatitude, lng: trip.jobDestinationLongitude });
          if (res) {
            let approxDO = moment(trip.approxPU).tz(this.timeZone).add(res, 'seconds');
            trip.approxDO = approxDO.toISOString();
            let appointmentTime = moment(trip.appointmentTime).tz(this.timeZone);
            trip.doTimeDiff = appointmentTime.diff(approxDO, 'minutes', true);
            trip.doTimeMsg = trip.doTimeDiff < 0 ? 'Late' : 'Early';
          }
        }
      }
    }
  }

  setDefaultApproximation(trip) {
    if (trip.job && trip.job.trackInfoJob) {
      if (this.isEventExist(trip.job.trackInfoJob.jobAccepted) && trip.job.trackInfoJob.jobAccepted.aproxTime) {
        // let approxPU = moment(trip.job.trackInfoJob.jobAccepted.aproxTime).tz(this.timeZone)
        // trip.approxPU = approxPU.toISOString();
        // let scheduleTime = moment(trip.scheduleTime).tz(this.timeZone);
        // trip.puTimeDiff = scheduleTime.diff(approxPU, 'minutes');
        // trip.puTimeMsg = trip.puTimeDiff < 0 ? 'Late' : 'Early';
        trip.approxPU = trip.job.trackInfoJob.jobAccepted.aproxTime;
        trip.puTimeDiff = moment(trip.scheduleTime).diff(moment(trip.approxPU), 'minutes', true);
      }
      if (this.isEventExist(trip.job.trackInfoJob.jobAproxDo) && trip.job.trackInfoJob.jobAproxDo.aproxTime) {
        // let approxDO = moment(trip.job.trackInfoJob.jobAproxDo.aproxTime).tz(this.timeZone);
        // trip.approxDO = approxDO.toISOString();
        // let appointmentTime = moment(trip.appointmentTime).tz(this.timeZone);
        // trip.doTimeDiff = appointmentTime.diff(approxDO, 'minutes');
        // trip.doTimeMsg = trip.doTimeDiff < 0 ? 'Late' : 'Early';
        trip.approxDO = trip.job.trackInfoJob.jobAproxDo.aproxTime;
        trip.doTimeDiff = moment(trip.appointmentTime).diff(moment(trip.approxDO), 'minutes', true);
      }

    }
  }

  isEventExist(event) {
    return event && event.coords.length === 2 && event.coords[0] && event.coords[1];
  }

  setView(type) {
    this.view = type;
    if (this.view === 'list') { // for reset timer and refetch data
      this.timer.init();
      this.timer.start();
      this.getAllTrips();
    }
  }

  toggleApprox(method) {
    if (method === 'google') {
      this.isGoogleApprox = !this.isGoogleApprox;
      if (this.isGoogleApprox) {
        this.isLocalApprox = false;
      }
    } else if (method === 'local') {
      this.isLocalApprox = !this.isLocalApprox;
      if (this.isLocalApprox) {
        this.isGoogleApprox = false;
      }
    }
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  shortStatus(status, jobStatus) {
    let str = '';
    if (status === 'unassigned') {
      str = 'UN';
    } else if (status === 'offered' || status === 'offered') {
      str = 'AS';
    } else if (status === 'inprogress') {
      if (jobStatus === 'onway') {
        str = 'OW'
      } else if (jobStatus === 'arrived') {
        str = 'AR'
      } else if (jobStatus === 'started') {
        str = 'MO'
      } else if (jobStatus === 'completed') {
        str = 'CP'
      }
    } else if (status === 'finished') {
      str = 'FN';
    } else if (status === 'cancelled') {
      str = 'CN'
    }

    return str;
  }

  getTripsCount() {
    let count = 0;
    if (this.alarmingTrips && this.alarmingTrips.length) {
      count = count + this.alarmingTrips.length;
    }

    if (this.inprogressTrips && this.inprogressTrips.length) {
      count = count + this.inprogressTrips.length;
    }

    if (this.scheduledTrips && this.scheduledTrips.length) {
      count = count + this.scheduledTrips.length;
    }

    if (this.cancelledTrips && this.cancelledTrips.length) {
      count = count + this.cancelledTrips.length;
    }

    return count;
  }

  convert(num) {
    // return Math.abs(num);
    return this.viewHourFormat(Math.abs(num) * 60000);
  }

  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.stationManagerList = data;
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  markRead(assign) {
    if (assign.viewStatus === "returned") return;
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip as acknowledged?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.viewStatus = "";
        assign.dispatchNoteTwo += ` Mark Acknowledged : ${this.user.displayName
          } ${moment().tz(`${this.timeZone}`).format("MM/DD/YY HHmm")}`;
        this.assignTripService
          .assignTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              // sweetAlert('Success', 'Ride Re-routed Successfully', 'success', 'OK');
              // this.closeActionMenu(null);
            }
          });
      }
    });
  }

  openfarmoutModal(uberTrip) {
    if (uberTrip.farmout && uberTrip.farmout.platform === 'lyft') {
      this.lyftDetailsModalObj = uberTrip;
    } else {
      this.farmoutDetails = uberTrip
      this.isFarmoutModal = true
    }
  }

  closelyftDetailsModal(evt) {
    this.lyftDetailsModalObj = null;
  }

  closeFarmoutModal(evt) {
    this.isFarmoutModal = evt
  }

  getAssisData() {
    this.assistService.getAllAssists()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.assists = data;
          // console.log('assists', this.assists);
          this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      });
  }

  ngOnDestroy() {
    if (this.tripAssistanceTimer) {
      clearInterval(this.tripAssistanceTimer);
    }
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.socketService.removeListener(Events.GET_ASSIGN_TRIP_ETA);
    window.removeEventListener("keyup", this.initializeTimer);

  }

  onToggleConfiguration() {
    this.getAllTrips();
  }

  markCompletedTrip(assign, listName) {
    sweetAlert(
      "Alert",
      "Are you sure you want to complete this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .markCompletedTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              const list = this[listName];
              const index = list.findIndex(t => t._id === assign._id);
              if (index > -1) {
                list.splice(index, 1);
              }
            }
          });
      }
    });
  }

  getStatusLabel(trip: any): string {
    switch (trip.jobStatus) {
      case 'pending':
        return 'Unassigned';
      case 'arrived':
        return 'On Scene';
      case 'started':
        return 'Member Onboard';
      case 'marketplaced':
        return 'Marketplace';
      default:
        return trip.jobStatus;
    }
  }

  isValidFarmoutFare(assign) {
    if (!assign.preSpecialRate && !assign.farmout && !assign.farmout.totalFare) return false;
    const rate = assign.preSpecialRate;
    const fare = assign.farmout.totalFare;
    return fare < rate * 0.8;
  }


  sortTrips(column: string) {
    Object.keys(this.columnsSortOrder).forEach(col => {
      if (col !== column) {
        this.columnsSortOrder[col] = '';
      }
    });

    if (!this.columnsSortOrder[column]) {
      this.columnsSortOrder[column] = 'asc';
    } else {
      this.columnsSortOrder[column] =
        this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
    }

    const order = this.columnsSortOrder[column];

    const sortFn = (a: any, b: any) => {

      let valA = a[column] || 0;
      let valB = b[column] || 0;

      // handle date
      if (column === 'scheduleTime' || column === 'appointmentTime') {
        valA = moment(valA).valueOf();
        valB = moment(valB).valueOf();
      }

      // handle numbers
      if (!isNaN(valA)) valA = Number(valA);
      if (!isNaN(valB)) valB = Number(valB);

      if (valA < valB) return order === 'asc' ? -1 : 1;
      if (valA > valB) return order === 'asc' ? 1 : -1;

      return 0;
    };
    this.inprogressTrips.sort(sortFn);
    this.scheduledTrips.sort(sortFn);
    this.alarmingTrips.sort(sortFn);
    this.markedReadyTrips.sort(sortFn);
    this.cancelledTrips.sort(sortFn);
  }

  editTrip(assign) {
    const fundingSource = assign.cooperate ? this.preCooperates[assign.cooperate] : null;
    if (fundingSource && fundingSource.companyType === 'taxi') {
      this.editTaxiRideModalObj = assign._id
      return;
    }
    this.editTripModalObj = assign._id;
  }

  onEditTrip(event) {
    if (event) {
      this.editTripModalObj = null;
      this.getAllTrips();
    }
  }

  onEditTaxiRide(event) {
    if (event) {
      this.editTaxiRideModalObj = null;
      this.getAllTrips();
    }
  }

  setPartialEditModal(trip) {
    this.partialEditModalObj = trip;
  }

  updateTripData(evt) {
    if (evt) {
      this.partialEditModalObj = null;
      this.getAllTrips();
    }
  }

  isTaxiRide(assign: any) {
    const fundingSource = assign.cooperate ? this.preCooperates[assign.cooperate] : null;
    return !!(fundingSource && fundingSource.companyType === 'taxi');
  }

}

